import type { RootState } from '../store';

export const selectPlans = (state: RootState) => state.pricing.plans;
export const selectIsPricingInitialized = (state: RootState) =>
  state.pricing.isInitialized;
export const selectLaunchPromo = (state: RootState) =>
  state.pricing.launchPromo;
